import { buildPrintHtml, openPrintWindow } from './printHtml';
import { downloadPrintPdf } from './printPdf';
import { downloadPrintHwp } from './printHwp';

export const PRINT_FORMATS = [
  { id: 'print', label: '인쇄', enabled: true, title: '브라우저 인쇄' },
  { id: 'pdf', label: 'PDF', enabled: true, title: 'PDF 파일 다운로드' },
  { id: 'hwp', label: 'HWP', enabled: true, title: 'HWP 파일 다운로드' },
  { id: 'hwpx', label: 'HWPX', enabled: false, title: '이후 지원' },
  { id: 'xls', label: 'XLS', enabled: false, title: '이후 지원' },
  { id: 'xlsx', label: 'XLSX', enabled: false, title: '이후 지원 · 엑셀 버튼 사용' },
  { id: 'doc', label: 'DOC', enabled: false, title: '이후 지원' },
  { id: 'docx', label: 'DOCX', enabled: false, title: '이후 지원' },
];

/**
 * @returns {Promise<{ ok: boolean, reason?: string }>}
 */
export async function renderPrintFormat(formatId, model, layout, fileName, ctx) {
  const id = String(formatId || '');
  if (id === 'print') {
    const html = buildPrintHtml(model, layout, ctx);
    return openPrintWindow(html);
  }
  if (id === 'pdf') {
    return downloadPrintPdf(model, layout, ctx, fileName);
  }
  if (id === 'hwp') {
    return downloadPrintHwp(model, layout, ctx, fileName);
  }
  return { ok: false, reason: '아직 지원하지 않는 형식입니다.' };
}
